import { definePreview } from 'storybook/preview-api';

var index_default=()=>definePreview({});

export { index_default as default };
